export var DecarbonizationPillar;
(function (DecarbonizationPillar) {
    DecarbonizationPillar["EnergyEfficiency"] = "ee";
    DecarbonizationPillar["Electrification"] = "el";
    DecarbonizationPillar["LowCarbonFuels"] = "lcf";
    DecarbonizationPillar["CarbonCapture"] = "ccus";
})(DecarbonizationPillar || (DecarbonizationPillar = {}));
export var Scope;
(function (Scope) {
    Scope[Scope["Scope1"] = 1] = "Scope1";
    Scope[Scope["Scope2"] = 2] = "Scope2";
    Scope[Scope["Scope3"] = 3] = "Scope3";
})(Scope || (Scope = {}));
export var CostScore;
(function (CostScore) {
    CostScore[CostScore["One"] = 1] = "One";
    CostScore[CostScore["Two"] = 2] = "Two";
    CostScore[CostScore["Three"] = 3] = "Three";
    CostScore[CostScore["Four"] = 4] = "Four";
    CostScore[CostScore["Five"] = 5] = "Five";
})(CostScore || (CostScore = {}));
export var SolutionOptionKey;
(function (SolutionOptionKey) {
    SolutionOptionKey["EnergyEfficiencyAndHeatRecoveryElectricity"] = "energyEfficiencyAndHeatRecoveryElectricity";
    SolutionOptionKey["EnergyEfficiencyAndHeatRecoveryNaturalGas"] = "energyEfficiencyAndHeatRecoveryNaturalGas";
    SolutionOptionKey["EnergyEfficiencyAndHeatRecoveryPropane"] = "energyEfficiencyAndHeatRecoveryPropane";
    SolutionOptionKey["EnergyEfficiencyAndHeatRecoveryFuelOil"] = "energyEfficiencyAndHeatRecoveryFuelOil";
    SolutionOptionKey["EnergyEfficiencyAndHeatRecoveryDiesel"] = "energyEfficiencyAndHeatRecoveryDiesel";
    SolutionOptionKey["EnergyEfficiencyAndHeatRecoveryGasoline"] = "energyEfficiencyAndHeatRecoveryGasoline";
    SolutionOptionKey["StationaryElectrificationNaturalGas"] = "stationaryElectrificationNaturalGas";
    SolutionOptionKey["StationaryElectrificationPropane"] = "stationaryElectrificationPropane";
    SolutionOptionKey["StationaryElectrificationFuelOil"] = "stationaryElectrificationFuelOil";
    SolutionOptionKey["MobileElectrificationDiesel"] = "mobileElectrificationDiesel";
    SolutionOptionKey["MobileElectrificationGasoline"] = "mobileElectrificationGasoline";
    SolutionOptionKey["LowNoCarbonFuelSwitchingNaturalGas"] = "lowNoCarbonFuelSwitchingNaturalGas";
    SolutionOptionKey["LowNoCarbonFuelSwitchingPropane"] = "lowNoCarbonFuelSwitchingPropane";
    SolutionOptionKey["LowNoCarbonFuelSwitchingFuelOil"] = "lowNoCarbonFuelSwitchingFuelOil";
    SolutionOptionKey["LowNoCarbonFuelSwitchingGasoline"] = "lowNoCarbonFuelSwitchingGasoline";
    SolutionOptionKey["LowNoCarbonFuelSwitchingDiesel"] = "lowNoCarbonFuelSwitchingDiesel";
    SolutionOptionKey["CoGenerationElectricity"] = "coGenerationElectricity";
    SolutionOptionKey["RenewablePurchaseFromUtilityElectricity"] = "renewablePurchaseFromUtilityElectricity";
    SolutionOptionKey["RenewableEnergyAsPpaVppaElectricity"] = "renewableEnergyAsPpaVppaElectricity";
    SolutionOptionKey["RenewableCreditsRecsElectricity"] = "renewableCreditsRecsElectricity";
    SolutionOptionKey["OnsiteSolarOrRenewableEnergyGenerationElectricity"] = "onsiteSolarOrRenewableEnergyGenerationElectricity";
    SolutionOptionKey["CarbonCaptureAndSequestrationCarbon"] = "carbonCaptureAndSequestrationCarbon";
    SolutionOptionKey["EliminateFugitiveEmissionsCarbon"] = "eliminateFugitiveEmissionsCarbon";
    SolutionOptionKey["OffsetsCarbon"] = "offsetsCarbon";
    SolutionOptionKey["RefrigerantLeaksRefrigerants"] = "refrigerantLeaksRefrigerants";
    SolutionOptionKey["LowGwpRefrigerantsRefrigerants"] = "lowGwpRefrigerantsRefrigerants";
})(SolutionOptionKey || (SolutionOptionKey = {}));
